import styled from 'styled-components';

export default styled.div`
	display: flex;
	gap: inherit;
	justify-content: space-between;
`;
